<template>
  <div
    class="row documents"
    v-if="showableDocuments.length > 0"
  >
    <div class="col-md-12">
      <div class="form-fieldhelp" style="right: 15px">
        <label>?</label>
        <div class="form-fieldhelp-text">
          <div>
            Прикрепите сканы документов в соответствующие для них разделы.
            <br/>Максимально допустимый размер файла - 2 МБ.
            <br/>Допустимые расширения файлов: jpg, jpeg, png, pdf, bmp, webp.
          </div>
        </div>
      </div>
      <div v-if="visitor.docError" class="form-fielderror" style="right: 40px">
        <label>!</label>
        <div class="form-fielderror-text">
          <div>Загрузите документы</div>
        </div>
      </div>
      <h4>Документы</h4>
      <div class="documents-flex-row row">
        <label class="flex-label residence-checkbox col-md-4"
               v-if="residenceCheckBoxCondition">
          <input type="checkbox"
                 id="checkbox"
                 @change="changeResidence"
          />
          <div class="control-label">{{ 'Имеется вид на жительство' }}</div>
        </label>
      </div>
    </div>

    <div class="col-md-12 panel-group documents-form-flex" :id="'documents' + visitorIndex">
      <template v-for="(documentObj, documentKey) in showableDocuments">
        <div :id="`visitor-document-block-${documentObj.document.short_name}`" :key="documentKey">
          <uppy-uploader
            v-model="visitor.files[documentObj.document.short_name]"
            :dashboard-show-condition="isNew || isDuplicate || isDraft || isEdit"
            :document-comment="documentObj.comment"
            :document-key="`visitor${visitorIndex}-${documentObj.document.short_name}`"
            :document-name="documentObj.document.name"
            :document-need-expire="documentObj.need_expire"
            :document-id="documentObj.document.id"
            :document-short-name="documentObj.document.short_name"
            :max-files-count="documentObj.document.max_file"
            entity-type="personal"
            :entity-id="visitor.personal.id"
            :documents-show-condition="isView"
            :files-request="requestVisitorFiles"
            :get-uuid="getUUID"
            :has-errors="blockHasErrors(documentObj.document.short_name)"
            :key="`${visitor.uuid}-${documentObj.document.short_name}`"
            :form="form"
            ref="uploader"
            @file-removed="onFileRemove($event, documentObj.document.short_name)"
            @change="change"
            @change-visitors="change"
            @file-added="change"
          />
          <div class="error-text" v-html="blockErrors(documentObj.document.short_name)"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import UppyUploader from '../../../inputs/UppyUploader';

export default {
  name: 'VisitorDocumentsFormBlock',
  components: { UppyUploader },
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  model: {
    prop: 'visitors',
    event: 'change-visitors'
  },

  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    nationalityDocuments: {
      type: Array,
      default: () => []
    },
    personalNationalities: {
      type: [Array, Object],
      default: () => []
    }
  },
  data: () => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL
  }),

  updated() {
    this.$refs?.uploader?.forEach((uppy) => {
      uppy.$forceUpdate()
      if (Object.hasOwn(this.visitor.personal, 'documents')) {
        if (Object.keys(this.visitor.files).length > 0) {
          this.cleanFiles()
        }
        for (let key in this.visitor.personal.documents) {
          this.visitor.personal.documents[key].forEach((upload) => {
            this.autoloadFile(key, upload)
          })
        }
        delete this.visitor.personal.documents
      }
    })
  },

  methods: {
    changeResidence() {
      this.visitor.personal.residence = this.visitor.personal.residence === 0 ? 1 : 0
    },

    autoloadFile(doctype, file) {
      this.$refs?.uploader?.forEach((uppy) => {
        if (uppy.getShortName() === doctype) {
          uppy.autoloadDocument(file)
        }
      })
    },

    changeDocuments() {
      this.visitor.personal.files = this.visitor.personal.files ?? []
    },

    blockHasErrors(field) {
      return this.hasError(this.errors?.visitors?.[this.visitorIndex]?.files, field)
    },

    blockErrors(field) {
      return this.hasError(this.errors?.visitors?.[this.visitorIndex]?.files, field)[0]
    },

    async fileRemoved(uuid, ext) {
      await ApiClient.removeUploadedDocument({ uuid, ext })
    },

    getUUID(file) {
      return file.uuid
    },

    onFileRemove(file, docName) {
      let ext = file.name.split('.').pop().toLowerCase()

      this.fileRemoved(file.meta.uuid, ext)
      this.removeVisitorFile(this.visitor, docName)
    },

    removeVisitorFile(visitor, docName) {
      if (visitor.files[docName].length === 0) {
        delete visitor.files[docName];
      }
    },

    cleanFiles() {
      Object.keys(this.visitor.files).forEach((key) => {
        delete this.visitor.files[key]
      })
    },

    change() {
      this.$emit('change-visitors', this.visitor)
    },

    async requestVisitorFiles(documentType) {
      let vue = this;

      await ApiClient.getUploadDocuments({
        personal_ids: JSON.stringify([this.visitor.personal.id]),
        doc_types: JSON.stringify([documentType])
      }).then(function (response) {
        const responseData = response.data.data
        if (responseData[vue.visitor.personal.id]?.[documentType]) {
          vue.visitor.files[documentType] = responseData[vue.visitor.personal.id][documentType]
        }
      })
    }
  },

  computed: {
    residenceCheckBoxCondition() {
      const nationality = this.personalNationalities.find(currentValue => currentValue.iso2 === 'RU')

      return this.visitor.personal.nationality_id !== 0 && this.visitor.personal.nationality_id !== nationality.id;
    },

    showableDocuments() {
      const nationality = this.visitor.personal?.nationality_id
      const nationalityDocuments = this.nationalityDocuments
      const docs = []
      let count = 0

      for (let i = 0; i < nationalityDocuments.length; i++) {
        if ((nationalityDocuments[i].nationality_id === null || Number(nationalityDocuments[i].nationality_id) === Number(nationality)) &&
          (this.visitor.personal.identification_id === nationalityDocuments[i].nationality_identification_id)) {
          if (nationalityDocuments[i].application_group_purpose_id &&
            nationalityDocuments[i].application_group_purpose_id !== this.form.application.application_group_purpose_id) {
            continue
          }
          if ((nationalityDocuments[i].residence_visible === 0 && this.visitor.personal.residence === 1) ||
            (nationalityDocuments[i].residence_visible === 1 && this.visitor.personal.residence === 0)) {
            continue
          }
          if (nationalityDocuments[i].region_id &&
            nationalityDocuments[i].region_id !== this.form.application.terminal_region_id) {
            continue
          }

          docs[count] = nationalityDocuments[i]
          count++
        }
      }

      return docs
    }
  }
}
</script>
